import { domain_ru } from '../config'

export const getIsRuServer = () => {
  return window.location.hostname === domain_ru
}
